import React from "react";
import { useAuth0 } from "../../react-auth0-spa";

const Logout = () => {

    const { isAuthenticated, logout } = useAuth0();

    if (isAuthenticated) {
        sessionStorage.clear(); 
        logout();
    }

    return;

}

export default Logout;